import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'
import { rgba, } from 'polished'
import PageTransition from 'gatsby-plugin-page-transitions'
import Transition from 'react-transition-group/Transition'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { Block, Share, MetaTags, ScrollProgress, Footer, Section } from '../components'

import { rgb, pageTransitionProps } from '../utils'
import { warmBrown, themes } from '../styles/themes'
import { container, padding, heading, bgImage, button, bgIcon, hoverState } from "../styles/global"
import logo from '../assets/images/logo.svg'
import { media, isClient } from "../styles/utils"
import { caption, paragraph, projectIntro } from "../styles/type"

import arrowBack from '../assets/icons/arrow-back.svg'

class CaseStudy extends Component {

	state = {
        data: [],
        acf: [],
        sections: [],
        heroActive: true
    }

	componentWillMount = () => {
		const data = this.props.data.wordpressCasestudy
        const acf = JSON.parse(data.acf_json)

		//console.log(acf)

		this.setState({
            data: data,
            acf: acf,
			sections: acf.sections
		})

		setTimeout(() => {
			this.setState({
				pageLoaded: true
			})
		}, 500);

		if (isClient()) {		
			// onscroll event won't work here because we are locking the viewport
			disableBodyScroll() 
			window.addEventListener('mousewheel', this.seenHeroSplash)
			window.addEventListener('touchstart', this.seenHeroSplash)
        }
		
        // set up timer to fade out hero splash
        this.timer = setInterval(
            this.seenHeroSplash,
            5000,
		)
	}
	
	componentDidMount = () => {
		disableBodyScroll() 
	}
	
	componentDidUpdate = (prevProps, prevState) => {
		const { heroActive } = this.state;

	    if (heroActive !== prevState.heroActive) {   
			if (heroActive) {
				disableBodyScroll() 
			} else {
				window.scrollTo(0,0); 

				setTimeout(() => {
					enableBodyScroll();
					document.body.style.overflow = 'auto';
				}, 1000);
			}
        }
	}

    componentWillUnmount() {
        window.removeEventListener('mousewheel', this.seenHeroSplash)
        clearInterval(this.timer);
    }

	seenHeroSplash = () => {
		if (this.state.heroActive) {
			this.setState({heroActive: false})
			clearInterval(this.timer);
		}
	}

	renderHeroSplash = () => {
		const { heroActive, acf, data, pageLoaded } = this.state;

		return (
			<HeroSplash
				active={heroActive}
				onClick={() => this.seenHeroSplash()}
				theme={acf.opening_screen_colour_theme.colour_theme}
				animate={pageLoaded}
			>
				<Heading>
					{data.title}
				</Heading>
				<Image
					alignment={acf.opening_screen_hero_position}
					src={acf.hero_image.sizes.medium2}
					animate={pageLoaded}
				/>
				{this.renderMeta()}
			</HeroSplash>
		)
	}

	renderSections = () => {
		const { sections } = this.state;

		return sections.map((section, i) => {
			const blocks = section.blocks;

			if (section.display_section && section.blocks) {
				return (
					<Section
						key={i}
						blocks={blocks}
						section={section}
						lastSection={i == sections.length - 1}
					/>
				)
			}
		})
    }
    
    renderCredits = () => {
        const { acf } = this.state;
        
        if (acf.credits) {
            const credits = acf.credits.map((credit, i) => {
                return (
                    <Credit
                        key={i}
                    >
                        <Name>{credit.title}</Name>
                        <Val>{credit.value}</Val>
                    </Credit>
                ) 
            })
            return (
                <Credits>{credits}</Credits>
            )
        }
	}

	renderMeta = () => {
		const { acf } = this.state;
		return (
			<Meta>
				{acf.location && (
					<Name>{acf.location}</Name>
				)}
				{acf.dates && (
					<Name>{acf.dates}</Name>
				)}
				{this.renderCredits()}
			</Meta>
		)
	}
	
	renderContent = () => {
        const { data, acf } = this.state;

       
		return (
			<React.Fragment>
				<Opening>
					<Left>
						{this.renderMeta()}
					</Left> 
					<Right>
						{acf.short_description && (
							<Description
								dangerouslySetInnerHTML={{__html: acf.short_description}}  
							/>
						)}
					</Right>
				</Opening>

                {this.renderSections()}
                
                <Footer 
                    title={data.title}
                    pageURL={isClient() ? window.location.href : '' }
                    backLink={'/'}
                    backLinkText={'Back to Home'}
                />

			</React.Fragment>
		)
	}

  	render() {
		const { data, acf, heroActive } = this.state;
		
		return (		
			<React.Fragment>

                <ScrollProgress/>

                {this.renderHeroSplash()}
                
				<PageTransition
					{...pageTransitionProps}
				>
                    {data && (
                        <MetaTags 
                            title={`Paul Conrad Architects — Case Study : ${data.title}`}
                            description={data.meta_description ? data.meta_description : ''}
                        />
                    )}
                    
					<Wrapper
                        active={!heroActive}
					>
						{this.renderContent()}
					</Wrapper>
				</PageTransition>
			</React.Fragment>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;
	overflow-x: hidden;
	transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
	transform: translateY(100px);
	opacity: 0;

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`

const Container = styled.div`
    ${container}
	display: flex;
	flex-direction: column;
`

// Shared

const Heading = styled.div`
	${heading}
`
const Title = styled.div``

// Hero


const HeroImage = styled.div``
const ProjectTitle = styled.div``
const Hero = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${warmBrown.background};

	${Container} {
		justify-content: center;
		align-items: center;
	}

	/* Animation */
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.5s ease-out;

	${props => {
		if (props.active) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}
`


// Opening

const Left = styled.div``
const Right = styled.div``
const Opening = styled.div`
	display: flex;
	flex-direction: row;
	width: 680px;
	max-width: 100%;
	padding-top: 25rem;
	padding-bottom: 25rem;

	${media.laptop`
		width: 530px;
	`}

	${media.tablet`
		display: block;
		width: auto;
	`}

	${media.phone`
		padding-top: 15rem;
		padding-bottom: 15rem;
		${padding};
	`}

	${Left} {
		flex: 0 1 200px;
		padding-right: 20px;

		${media.laptop`
			flex: 0 1 150px;
		`}

		${media.tablet`
			display: none;
		`}
	}

	${Right} {
		flex: 0 1 440px;
		padding-left: 20px;

		${media.laptop`
			flex: 0 1 340px;
		`}

		${media.tablet`
			width: 360px;
			max-width: 100%;
			margin-left: auto;
			margin-right: auto;
			padding-left: 0;
		`}
	}
`

const Name = styled.div``
const Credit = styled.div``
const Val = styled.div`` 
const Credits = styled.div``

const Meta = styled.div`
    * {
        ${caption};
        text-indent: 0!important;
    }

    > ${Credits} > ${Credit} {
        margin-top: 1rem;

        > ${Name} {
            font-weight: 400;
        }
    }
`

const Description = styled.div`
    &, > * {
        ${projectIntro};
    }
`

// Hero

const fadeUp = css`
	transform: translateY(30px);
	will-change: transform;
	transition: all 1s ease;
	opacity: 0;

	${props => {
		if (props.animate) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`

const HeroSplash = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: ${warmBrown.background};
	z-index: 11;
	padding: 5rem;
	display: flex;
    flex-direction: column;

	${Meta} {
		display: none;
		flex-direction: column;

		font-family: 'Scto';
		font-size: 10.5px;
		color: #FFFFFF;
		line-height: 12px;

		position: absolute;
		bottom: 10rem;
		left: 50%;
		transform: translateX(-50%);
	}

	${Heading} {
		font-family: 'Scto';
		font-size: 50px;
		color: #3A4A59;
		letter-spacing: -0.8px;
		text-align: center;
		line-height: 50px;

		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		${fadeUp}
		transform: translate(-50%, calc(-50% + 30px)); 

		${props => {
			if (props.animate) return css`
				transform: translate(-50%, -50%); 
				opacity: 1;
			`
		}}

		${media.laptop`
			font-size: 37.5px;
			letter-spacing: -0.6px;
			line-height: 42px;
		`}
	}

	/* Animation */

	opacity: 0;
	pointer-events: none;
	transition: opacity 0.5s ease-out;

	${props => {
		if (props.active) return css`
			opacity: 1;
			pointer-events: all;
		`
	}}

	/* Theme */

	${props => {
		if (props.theme) {
			const theme = themes[props.theme];
			return css`
				background: ${theme.background};

				${Heading} {
					color: ${theme.text}
				}

				${Name} {
					color: ${theme.text}
				}
			`
		}
	}}

	/* Responsive */

	${media.tablet`
		padding-bottom: 10rem;

		${Meta} {
			display: flex;
		}
	`}

	${media.phone`
		padding: 0;
		padding-bottom: calc(40px + env(safe-area-inset-bottom));

		${Heading} {
			top: calc(50% + 32px);
			width: calc(100% - 80px);
			transform: translate(-50%, 0);
			font-size: 30px;
			letter-spacing: -0.48px;
			line-height: 30px;
		}

		${Meta} {
			left: calc(50% + 40px);
		}
	`}

`

const Image = styled.img`
	width: 100%;
	height: 100%;
	max-width: 70vw;
	max-height: 70vh;
    object-fit: contain;
    object-position: left;

	${media.laptop`
		max-width: 60vw;
		max-height: 60vh;
	`}

	${props => {
		if (props.alignment == 'right') return css`
			align-self: flex-end;
			object-position: right;
		`
	}}

	/* Animation */
	${fadeUp}
	transition-delay: 0.6s;

	${media.phone`
		height: 50vh;
		max-width: 100vw;
		object-fit: cover;
	`}
`


export default CaseStudy


export const pageQuery = graphql`
	query CaseStudy {
		wordpressCasestudy {
            title
			acf_json
		}
	}
`


// WEBPACK FOOTER //
// ./src/pages/CaseStudy.js